import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}dtac-game`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const dtacGamingApi = {
  postSendReceipt: (request) => {
    // page_id
    // order_id
    const { data } = request
    return instance().post(`/send-receipt`, data)
  }
}

export default dtacGamingApi



// WEBPACK FOOTER //
// ./src/api/dtac-gaming.js